<template>
    <div class="edit-profile">
        <div class="box">
            <Advertisement/>
        </div>
        <div class="box" ref="formContainer">

       
        <div class="edits">
                <SystemNotification v-if="message != null" :message="message"/>
               <div class="heading2-section">
                    Sign Up
                </div>
            <form @submit.prevent="signUp">
        
            <div class="mb-3">
            <label class="form-label">Who Are You?</label>
                <select @change="userTypeSelected" class="form-select form-input" v-model="user.userType" aria-label="Default select example">
                <option value="JobSeeker">A Job Seeker (Vocation&trade; JobSeeker)</option>
                <option value="Employer">An Employer (Vocation&trade; Enterprise)</option>
                </select>
            </div>
             <div v-if="employerSelected" class="mb-3">
                <label class="form-label">Vocation ID</label>
                <input type="text" v-model="user.handle" placeholder="Unique Vocation ID" class="form-control">
                <small  class="form-text text-muted" style="color:var(--page-header)!important;">A name that points to your business profile.</small>
            </div>
            <div class="mb-3">
            <label class="form-label">Fullname</label>
            <input type="text" v-model="user.fullname" placeholder="Personal / Business Name" class="form-control">
            </div>
            <div class="mb-3">
                <label class="form-label">Email</label>
                <input type="text" v-model="user.email" placeholder="email@example.com" class="form-control">
                <small v-if="employerSelected" class="form-text text-muted" style="color:var(--page-header)!important;">Use an Email you would want applications be directed to.</small>
            </div>
            <div class="mb-3">
                <label class="form-label">Phone</label>
                <input type="text" v-model="user.phone" placeholder="Personal / Business Phone(s)" class="form-control">
            </div>
        
            <div class="mb-3">
                <label class="form-label">Password</label>
                <input type="password" v-model="user.password" class="form-control">
            </div>
            <div class="mb-3">
                <label class="form-label">Confirm Password</label>
                <input type="password" v-model="user.confirmPassword" class="form-control">
            </div>
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" v-model="user.hasAgreed" id="checkDefault">
              <label class="form-check-label" for="checkDefault">
                I accept the <router-link class="small-link" to="/terms-of-service">Terms of Service</router-link> and consent to the collection and 
                processing of my account data as detailed in the <router-link class="small-link" to="/privacy-policy">Privacy Policy</router-link>.
              </label>
            </div>
            <div class="mb-4">
                <div ref="recaptchaEl"></div>
            </div>

            <div class="form-buttons mb-3">

                <button type="submit" class="btn btn-default primary-btn primary-btn-disabled" disabled v-if="loading">Signing Up...</button>
                <button type="submit" class="btn btn-default primary-btn" :disabled="user.hasAgreed == false" v-else>Sign Up</button>
                </div>
        
            <div class="errors" v-if="hasErrors" ref="formErrorsContainer">
                <div class="error" v-for="error in errors">{{ error }}</div>
            </div>
           
            </form>
            <router-link class="bottom-link-mobile" style="text-decoration:none;color:var(--sidenav-link-active);font-weight: bold;" to="/login">Go To Login</router-link>
            <LoadingIndicator v-if="loading"/>
        </div>

         </div>
      
    </div>
    <ConfirmationMessageModal :title="modal.caption" :body="modal.message" :button-label="modalButtonLabel" :close-modal="() => closeModal()"/>
</template>
<script>
import { signUpAsync } from '@/services/authService';
import ConfirmationMessageModal from '@/components/modals/ConfirmationMessageModal.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import Modal from 'bootstrap/js/dist/modal'
import Advertisement from '../shared/Advertisement.vue';
import SystemNotification from '@/components/Utility/SystemNotification.vue';
export default {
    components:{
        LoadingIndicator,
        ConfirmationMessageModal, Advertisement, SystemNotification
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            recaptchaWidgetId: null,
            user:{
                    fullname:"",
                    handle:"",
                    email:"",
                    phone:"",
                    userType:"",
                    password:"",
                    confirmPassword:"",
                    hasAgreed: false,
                    recaptchaToken:""
                },
            modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            modalButtonLabel:'Log In',
            message: this.$route.query.message,
            employerSelected: false
            
        }
    },
    mounted(){
        this.confirmModal = new Modal(document.getElementById('confirmMessageModal'))
        this.$refs.formContainer.parentElement.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        window.scrollTo({top: 0,behavior: 'smooth'});

        this.renderRecaptcha();
    },
   methods:{
    renderRecaptcha(){
        if (window.grecaptcha && window.grecaptcha.render) {
            this.recaptchaWidgetId = window.grecaptcha.render(this.$refs.recaptchaEl, {
                sitekey: this.sitekey
            });
        } else {
            // script may not have loaded yet — poll briefly
            setTimeout(this.renderRecaptcha, 300);
        }
    },
    verifyRecaptchaResponse(){
        let recaptchaToken = window.grecaptcha.getResponse(this.recaptchaWidgetId);
        if (!recaptchaToken){
            let err = new Error();
            err.message = "Please complete the reCAPTCHA verification.";
            throw err;
        }
        return recaptchaToken;
    },
     async signUp(){
        try{
            this.resetOnNewSubmit();
            let recaptchaToken = this.verifyRecaptchaResponse();
            this.user.recaptchaToken = recaptchaToken;
            var data = await signUpAsync(this.user);
            this.loading = false;
            if(data.success){
                sessionStorage.setItem('signup-email', this.user.email);
                this.$router.push("/verification");
        }else{
            if(data.errors){
                   
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                });
                this.hasErrors = true;
                 this.$nextTick(() => {
                        this.$refs.formErrorsContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
                });
                window.grecaptcha.reset(this.recaptchaWidgetId); //Reset recaptcha
                return;
            }
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            let message = e.message || "Something went wrong. Please try later";
            this.errors.push(message);
            this.hasErrors = true;
            this.$nextTick(() => {
                        this.$refs.formErrorsContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
            });
            window.grecaptcha.reset(this.recaptchaWidgetId); //Reset recaptcha
        }     
    },
    resetOnNewSubmit(){
            this.loading = true;
            this.hasErrors = false;
            this.errors = [];
            this.modalButtonLabel = 'Log In'
    },
     closeModal(){
      this.confirmModal.hide();
      if(this.modalButtonLabel == 'Log In'){
      this.$router.push('/login');
      }
    },
    showModal(){
        this.confirmModal.show();
    },
    userTypeSelected(){
        if(this.user.userType === 'Employer'){
            this.employerSelected = true;
        }else{
            this.employerSelected = false;
            this.handle = ""; 
        }
    }
   }
}
</script>
<style scoped>

.primary-btn{
    width:100%;
}

.small-link{
    color:var(--signup-links);
    text-decoration: none;
}

.edit-profile{
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    margin-top:1.4rem;
}

.box:last-child{
    overflow-y: auto;
    max-height:80vh;
}

.box:last-child::-webkit-scrollbar {
  width: 8px;
}

.box:last-child::-webkit-scrollbar-track {
  background: var(--list-item);
  border-radius: 4px;
  border:0px;
}

.box:last-child::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color);
  border-radius: 4px;
  border: 2px solid var(--nav);
}

.box:last-child::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-color);
}

.edits{
    grid-column:2/3;
    padding:1rem 5rem;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

input, select{
    border:0px!important;
}

select{
  background-color:var(--input-background)!important;
  color:var(--foreground)!important;
}



.bottom-link-mobile{
    display: none;
}




@media (max-width:768px) {
     .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
    padding:0rem 0.1rem;
}

.box:first-child{
    display: none;
}

.edit-profile{ 
    margin:1rem 0rem;

    grid-template-columns: auto ;
}

.advertisement{
    display: none;

}

.bottom-link-mobile{
    display: block;
}
}
</style>